import { render, staticRenderFns } from "./empty-messages.vue?vue&type=template&id=2cb137d4&scoped=true&"
import script from "./empty-messages.vue?vue&type=script&lang=js&"
export * from "./empty-messages.vue?vue&type=script&lang=js&"
import style0 from "./empty-messages.vue?vue&type=style&index=0&id=2cb137d4&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb137d4",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
installComponents(component, {VProgressCircular})


/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2cb137d4')) {
      api.createRecord('2cb137d4', component.options)
    } else {
      api.reload('2cb137d4', component.options)
    }
    module.hot.accept("./empty-messages.vue?vue&type=template&id=2cb137d4&scoped=true&", function () {
      api.rerender('2cb137d4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/aawz-intelligence-v2/components/empty-messages/empty-messages.vue"
export default component.exports